// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-course {
    margin-top: 10px;
}

.datepicker {
    display: table-cell !important;
}

.ant-input {
    border: none;
}
.ant-input:focus {
    border: none !important;
    outline: none;
}

.btn-submit {
    margin-bottom: 100px;
    float: right;
    margin-top: 10px;
}

.fa-plus {
    margin-left: 5px;
    color: #198754;
}

.add-term hr {
    margin-top: 10px;
}

.delete-term-btn button {
    margin-left: 5px;
}

button .fa-plus, .fa-minus {
    color: #fff;
    margin: 0px 5px 0px 0px;
}

.term-container hr {
    margin-top: 10px;
}

.term-text-container {
    /* display: flex;
    align-items: center; */
}

.term-text-container span {
    width: 40px;
}

.term-text-container input {
    width: 80px;
}

.qualification {
    margin-top: 30px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Course/Create/Create.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;0BACsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".create-course {\r\n    margin-top: 10px;\r\n}\r\n\r\n.datepicker {\r\n    display: table-cell !important;\r\n}\r\n\r\n.ant-input {\r\n    border: none;\r\n}\r\n.ant-input:focus {\r\n    border: none !important;\r\n    outline: none;\r\n}\r\n\r\n.btn-submit {\r\n    margin-bottom: 100px;\r\n    float: right;\r\n    margin-top: 10px;\r\n}\r\n\r\n.fa-plus {\r\n    margin-left: 5px;\r\n    color: #198754;\r\n}\r\n\r\n.add-term hr {\r\n    margin-top: 10px;\r\n}\r\n\r\n.delete-term-btn button {\r\n    margin-left: 5px;\r\n}\r\n\r\nbutton .fa-plus, .fa-minus {\r\n    color: #fff;\r\n    margin: 0px 5px 0px 0px;\r\n}\r\n\r\n.term-container hr {\r\n    margin-top: 10px;\r\n}\r\n\r\n.term-text-container {\r\n    /* display: flex;\r\n    align-items: center; */\r\n}\r\n\r\n.term-text-container span {\r\n    width: 40px;\r\n}\r\n\r\n.term-text-container input {\r\n    width: 80px;\r\n}\r\n\r\n.qualification {\r\n    margin-top: 30px !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
